module.exports = __webpack_public_path__ + "static/peachtropicalromper-43d712cc5b44c14dff90480f513cf9a1.jpeg";